// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3bO57","content":"GlobalSearch_content__-EsB2"};